export enum FormAction {
  Reset = 'Reset',
  Submit = 'Submit',
  Cancel = 'Cancel'
}
